/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

// Expose lodash methods here and let webpack tree shake the excess to avoid massive bundle

// Keep Alphabetized!!
import assign from 'lodash/assign';
import clamp from 'lodash/clamp';
import cloneDeep from 'lodash/cloneDeep';
import debounce from 'lodash/debounce';
import extend from 'lodash/extend';
import fill from 'lodash/fill';
import filter from 'lodash/filter';
import findIndex from 'lodash/findIndex';
import forIn from 'lodash/forIn';
import forOwn from 'lodash/forOwn';
import get from 'lodash/get';
import indexOf from 'lodash/indexOf';
import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';
import omit from 'lodash/omit';
import pick from 'lodash/pick';
import groupBy from 'lodash/groupBy';
import range from 'lodash/range';
import result from 'lodash/result';
import sortBy from 'lodash/sortBy';
import throttle from 'lodash/throttle';
import uniqueId from 'lodash/uniqueId';
import toPairs from 'lodash/toPairs';

export {
	assign,
	clamp,
	cloneDeep,
	debounce,
	extend,
	fill,
	filter,
	findIndex,
	forIn,
	forOwn,
	get,
	indexOf,
	isEmpty,
	isEqual,
	omit,
	pick,
	groupBy,
	range,
	result,
	sortBy,
	throttle,
	uniqueId,
	toPairs,
};
